import { render } from "./Page5.vue?vue&type=template&id=74025ebc&scoped=true"
import script from "./Page5.vue?vue&type=script&lang=js"
export * from "./Page5.vue?vue&type=script&lang=js"

import "./Page5.vue?vue&type=style&index=0&id=74025ebc&scoped=true&lang=css"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74025ebc"]])

export default __exports__